module.exports = __webpack_public_path__ + "static/media/ic-arrow-left-gray.2e4620e9.svg";